<script lang="ts">
  import type { LayoutProps } from './$types';

  const { children }: LayoutProps = $props();
</script>

<main class="container py-3" id="main-content">
  {@render children?.()}
</main>
